import styled, { css } from 'styled-components'

const StyledLinkStyles = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.forecast.text3};
`

export const ExternalLink = styled.a`
  ${StyledLinkStyles}
`
